import React from 'react';

import { Construction } from 'lucide-react';

interface ComingSoonPageProps {
  title?: string;
  description?: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({
  title = 'Coming Soon',
  description = 'This module is being prepared. Please check back later.',
}) => {
  return (
    <div className="p-6">
      <div className="max-w-2xl rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-950 p-8 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600 dark:bg-brand-950 dark:text-brand-300">
            <Construction className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">
              {title}
            </h1>
            <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
